(function() {
    'use strict';
    
a3_cabin_reports.factory('PastDutyFactory', PastDutyFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name PastDutyFactory
    * @description 
    * Get Past  Duties.
    * @ngInject
    */ 
function PastDutyFactory($http, apiUrl) {

    var service = {
        getPastDuties: getPastDuties,
        getNotStartedDuties: getNotStartedDuties
    };

    function getPastDuties(selectedDate, callback) {
        return $http.get(apiUrl + '/Training/GetPastDuties?specificDutyDate=' + selectedDate, { 'Content-Type': 'application/json' })
        .catch(callback);         
    } 
    
    function getNotStartedDuties(selectedDate, callback) {
        return $http.get(apiUrl + '/Training/GetNotStartedDuties?specificDutyDate=' + selectedDate, { 'Content-Type': 'application/json' })
        .catch(callback); 
    }        
    return service;
}
})();